import React from 'react'
import style from './messageBoard.style'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import Wrapper from '../wrapper/'
import { ChanelsMenu, ChanelsManualMenu } from '../app-icon/Icons'

const MessageBoard = ({ classes }) => {
  return (
    <Wrapper
      shadow={2}
      style={{
        borderRadius: 8,
        overflow: 'hidden',
        border: 'solid 3px #ffcc00',
        padding: '25px 30px 10px 30px',
        transform: 'scale(1)',
        animationName: 'scale',
        animationIterationCount: 'infinite',
        animationDuration: '2s',
        willChange: 'transform',
      }}
    >
      <Typography style={{ fontWeight: 600 }} variant="body1">
        Настройка системы не завершена.
      </Typography>
      <ul className={classes.items}>
        <Typography component="li" variant="body2">
          Добавьте каналы для автоматического импорта рекламных расходов
          <a href="/sources" className={classes.link}>
            <ChanelsMenu />
            <span style={{ marginLeft: 16 }}>Добавить каналы</span>
          </a>
        </Typography>
        <Typography component="li" variant="body2">
          Вы можете добавить рекламные расходы вручную
          <a href="/statistics" className={classes.link}>
            <ChanelsManualMenu />
            <span style={{ marginLeft: 16 }}>Добавить расходы вручную</span>
          </a>
        </Typography>
      </ul>
    </Wrapper>
  )
}

export default style(MessageBoard)
